module.exports = __webpack_public_path__ + "static/media/icon-wetdooropen.1d88d044.svg";